import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Status = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 5px;
  padding: 5px 10px;
  color: ${({ upproved }) => (upproved ? COLORS.success : COLORS.gray60)};

  svg {
    margin-right: 5px;
  }

  &:last-child {
    margin-right: 0;
    padding-right: 0;
  }
`;

export default Status;
